import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import allRouter from './router'

Vue.use(Router)


// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


let router =  new Router({
  mode: 'history',
  routes: [
    ...allRouter,
    { 
      path: '*', 
      component: r => require.ensure([], () => r(require(`@/pages/dashboard/index`)), 'dashboardIndex'),
      meta:{
        tit:'我的看板'
      }
    },
    {
      path:'/',
      redirect:'/dashboard/index',
      meta:{
        tit:'我的看板'
      }
    },
    {
      path: '/dashboard/index',
      name: 'dashboardIndex',
      component: r => require.ensure([], () => r(require(`@/pages/dashboard/index`)), 'dashboardIndex'),
      meta:{
          tit:'我的看板'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: r => require.ensure([], () => r(require(`@/pages/user/login`)), 'login'),
    }
  ]
})

let nextRouter = {}, isNextrouter = false;
router.beforeEach((to,from,next)=>{
  if(to.path ==='/login'){
    next();
  }else {
    let token = localStorage.getItem('token');
    let refresh_token = localStorage.getItem('refresh_token');
    let access_token = localStorage.getItem('access_token');
    if( !token || !refresh_token || !access_token ){
      next('/login?path='+to.fullPath);
    }else {
      // console.log(store.state.user.INFO)
      if(  JSON.stringify( store.state.user.INFO ) === '{}' ){
        store.dispatch('user/GET_USER_INFO',{
          token
        }).then(dt=>{
          store.commit('user/SET_USER_INFO',dt)
        })
      }
      if( store.state.MENU_LIST.length === 0 ){
        store.dispatch('GET_MENU_LIST',{token}).then(dt=>{
          // console.log('menu',dt)
        })
      }
      store.commit('SET_PAGE_TITLE',to.meta.tit);
      if( to.path === '/home/search' ){
        next({
          path: '/local/index',
          query: to.query
        }) 
      }
      next();
    }
  }
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js